export default {
  'puppyclub:puppy-phase:A': 'The Pets Deli Paws Club - register now for free!',
  'puppyclub:puppy-phase:B': 'About my puppy',
  'puppyclub:puppy-phase:C': 'About me',

  'puppyclub:register': 'REGISTER FOR FREE',

  'puppyclub:puppy-phase:thank-you':
    'Thank you for your registration and welcome to the Pets Deli Paws Club!',
  'puppyclub:puppy-phase:thank-you-email-confirmation':
    'We will send you a confirmation by email - check it out right away!',
  'puppyclub:puppy-phase:thank-you-subtitle':
    'In the coming weeks, you can expect great exclusive offers, lots of helpful information about your puppy, and of course, lots of paws content. Have fun!',
};
